import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import { BookingStates } from '../../../../../constants/booking-states';
import { CTAButton } from '../../../shared-components/buttons/cta-button';
import { checkIsGuestView } from '../../common/utils/check-is-guest-view';

const getBtnConfig = (booking, isGuestView) => {
  switch (booking.obj_state) {
    case BookingStates.REQUESTED: {
      return isGuestView
        ? {
            path: 'current-details',
            text: (
              <FormattedMessage
                id='inbox.summary_props.active_view_receipt'
                defaultMessage='View Receipt'
              />
            )
          }
        : {
            path: 'review-request',
            text: (
              <FormattedMessage
                id='inbox.summary_props.active_booking_details'
                defaultMessage='Review Booking Details'
              />
            )
          };
    }
    case BookingStates.OFFER_SUBMITTED: {
      return {
        path: 'review-offer',
        text: (
          <FormattedMessage
            id='inbox.summary_props.review_offer'
            defaultMessage='Review offer'
          />
        )
      };
    }
    case BookingStates.GUEST_UPDATE_REQUESTED: {
      return {
        path: 'review-booking-update',
        text: (
          <FormattedMessage
            id='inbox.summary_props.guest_review_requested_update'
            defaultMessage='View Requested Update'
          />
        )
      };
    }
    case BookingStates.HOST_UPDATE_REQUESTED: {
      return {
        path: 'review-offer',
        text: (
          <FormattedMessage
            id='inbox.summary_props.host_review_update'
            defaultMessage='Review Update'
          />
        )
      };
    }
    case BookingStates.ACTIVE:
    case BookingStates.EXECUTED:
    case BookingStates.EXPIRED:
    case BookingStates.WITHDRAWN:
    case BookingStates.DECLINED:
    case BookingStates.CANCELLED:
    default: {
      return {
        path: 'current-details',
        text: isGuestView ? (
          <FormattedMessage
            id='inbox.summary_props.active_view_receipt'
            defaultMessage='View Receipt'
          />
        ) : (
          <FormattedMessage
            id='inbox.summary_props.active_booking_details'
            defaultMessage='Review Booking Details'
          />
        )
      };
    }
  }
};

export const BookingDetailsBtn = ({ booking, iosWebViewConfig, profile }) => {
  const isGuestView = checkIsGuestView(profile, booking);
  const btnConfig = getBtnConfig(booking, isGuestView);

  return iosWebViewConfig?.isWebView &&
    !!iosWebViewConfig?.renderReviewOfferDetails ? (
    <CTAButton
      onClickAction={() =>
        iosWebViewConfig.renderReviewOfferDetails(
          booking.obj_state,
          !isGuestView
        )
      }
      buttonText={btnConfig.text}
      classNameString='btn full-width btn-default text-wrap'
      isDisabled={false}
    />
  ) : (
    <Link
      to={`/inbox/${booking.booking_id || booking._id}/${btnConfig.path}`}
      className='btn btn-default full-width text-wrap'
      data-testing-id='booking-details-btn-text'
    >
      {btnConfig.text}
    </Link>
  );
};

BookingDetailsBtn.propTypes = {
  booking: PropTypes.object.isRequired,
  isGuestView: PropTypes.bool
};
